import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=08ea9731&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"
import style0 from "./Files.vue?vue&type=style&index=0&id=08ea9731&prod&lang=scss&scoped=true"
import style1 from "./Files.vue?vue&type=style&index=1&id=08ea9731&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea9731",
  null
  
)

export default component.exports